<template>
<div class="chapter">
<div class="inner_page">
<div class="img_container"><a id="page_9"></a><img alt="image" src="images/f0009-01.jpg"/>
</div>
<h1 class="toc-header">CONTENTS</h1>
<h2 class="toc"><a href="#/xhtml/02_Chapter01">Chronicle of a Friendship <em class="italic">by</em> William Spratling</a></h2>
<h2 class="toc"><span href="#/xhtml/06_Chapter02" title="Link target outside of Sample">Sherwood Anderson and Other Famous Creoles <em class="italic"></em></span></h2>
<h2 class="toc"><span href="#/xhtml/07_Chapter03" title="Link target outside of Sample">William Spratling’s Mexican World <em class="italic">by</em> Robert David Duncan</span></h2>
<a id="page_10"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?58107fa8